import SendbirdChat from "@sendbird/chat";
import { MessageMetaArray } from "@sendbird/chat/message";
import { GroupChannelHandler, GroupChannelModule, GroupChannelFilter, GroupChannelListOrder } from "@sendbird/chat/groupChannel";
import appSettings from "@/appSettings";
import store from "@/store";
import companyService from "./companyService";

const channelHandlers = {
  onChannelsAdded: (context, channels) => {
    /*const updatedChannels = [...channels, ...stateRef.current.channels];
        updateState({ ...stateRef.current, channels: updatedChannels, applicationUsers: [] });*/
    console.log("you have been added to channels ...................", channels);
    channels.forEach(c => console.log(`you have been added to channel ${c.name}`));
  },
  onChannelsDeleted: (context, channels) => {
    /*const updatedChannels = stateRef.current.channels.filter((channel) => {
            return !channels.includes(channel.url);
        });
        updateState({ ...stateRef.current, channels: updatedChannels });*/
    console.log("deleted channel ...............", channels);
    channels.forEach(c => console.log(`channel ${c.name} has been deleted`));
  },
  onChannelsUpdated: (context, channels) => {
    // const updatedChannels = stateRef.current.channels.map((channel) => {
    //     const updatedChannel = channels.find(incomingChannel => incomingChannel.url === channel.url);
    //     if (updatedChannel) {
    //         return updatedChannel;
    //     } else {
    //         return channel;
    //     }
    // });

    // updateState({ ...stateRef.current, channels: updatedChannels });
    console.log("updated channel ..................", channels);
    channels.forEach(c => console.log(`channel ${c.name} was updated`));
  },
  onMessagesAdded: (context, channel, messages) => {
    console.log(`message received on the channel that you are part in`);
    console.log("messages are: ");
    messages.forEach(m => {
      console.log(m);
    });
  },
  onMessagesUpdated: (context, channel, messages) => {
    console.log(`message received on the channel that you are part in`);
    console.log("messages are: ");
    messages.forEach(m => {
      console.log(m);
    });
  },
};

export default {
  chat: null,
  company: null,
  chatId: null,
  isConnected() {
    return this.chat !== null && this.chatId !== null;
  },
  async disconnect() {
    // Only disconnect if we have a chat instance (may be connecting or connected)
    if (!this.chat) return;
    try {
      await this.chat.disconnect();
    } catch (e) {
      // fire-and-forget — don't block logout or company switch
    }
    this.chat = null;
    this.chatId = null;
    this.company = null;
    store.commit("chatStore/clearState");
  },
  async init(company) {
    if (this.isConnected()) return;
    this.company = company;
    const chat = SendbirdChat.init({
      appId: appSettings.sendBirdAppId,
      modules: [new GroupChannelModule()],
    });

    const chatId = this.company.code + "-" + this.company.pakServiceId;
    try {
      let sessionToken = await companyService.getSendBirdSessionToken(chatId);
      await chat.connect(chatId, sessionToken);
    } catch (e) {
      this.chat = null;
      this.chatId = null;
      this.company = null;
      throw e;
    }

    this.chat = chat;
    this.chatId = chatId;

    const userUpdateParams = {
      nickname: company.name,
      userId: this.chatId,
    };
    await this.chat.updateCurrentUserInfo(userUpdateParams);
  },
  async loadChannels() {
    try {
      const groupChannelFilter = new GroupChannelFilter();
      groupChannelFilter.includeEmpty = true;
      var collection = this.chat.groupChannel.createGroupChannelCollection({
        filter: groupChannelFilter,
        order: GroupChannelListOrder.LATEST_LAST_MESSAGE,
      });
      collection.setGroupChannelCollectionHandler(channelHandlers);

      const handler = new GroupChannelHandler();
      handler.onMessageReceived = (channel, message) => {
        this.handleNewMessage(channel, message);
      };
      this.chat.groupChannel.addGroupChannelHandler("NEW_MESSAGE_HANDLER", handler);

      let groupChannels = await collection.loadMore();

      for (const channel of groupChannels) {
        await this.loadMessages(channel);
      }

      store.commit("chatStore/updateChannels", groupChannels);
      store.commit("chatStore/setSendbirdConnected", true);
    } catch (e) {
      console.log(e);
    }
  },
  async loadMessages(channel) {
    const params = {
      limit: 100,
      reverse: true,
      includeMetaArray: true,
    };

    const query = channel.createPreviousMessageListQuery(params);
    try {
      channel.messages = await query.load();
    } catch (e) {
      console.log(e);
    }
  },
  async loadRecipientParties() {
    store.dispatch("chatStore/updateRecipientParties");
  },
  async createGroup(toParty) {
    try {
      const groupName = this.getGroupName(toParty);
      const reverseGroupName = this.getGroupNameReversed(toParty);

      const existingChannel = store.getters["chatStore/channels"].find(
        channel => channel.name === groupName || channel.name === reverseGroupName
      );

      if (existingChannel) {
        console.log("Channel already exists:", existingChannel);
        return existingChannel;
      }

      const metadata = JSON.stringify({
        product: "pakdocs",
        fromCompanyId: this.company.id,
        fromCompanyCode: this.company.code,
        toCompanyCode: toParty.connectedCompanyCode,
        fromPartyId: toParty.id,
        toCompanyId: toParty.connectedCompanyId,
      });

      const channelParams = {
        name: groupName,
        invitedUserIds: [toParty.userId],
        isDistinct: true,
        data: metadata,
      };

      const newChannel = await this.chat.groupChannel.createChannel(channelParams);
      console.log("Created new channel:", newChannel);

      store.commit("chatStore/updateChannels", [...store.getters["chatStore/channels"], newChannel]);

      return newChannel;
    } catch (error) {
      console.error("Error creating group:", error);
      throw error;
    }
  },
  async sendMessage(toParty, msg, userName) {
    const channel = await this.createGroup(toParty);
    let msgParams = { message: msg, metaArrays: [new MessageMetaArray({ key: "senderUser", value: [userName] })] };

    return new Promise((resolve, reject) => {
      channel
        .sendUserMessage(msgParams)
        .onSucceeded(message => {
          this.handleNewMessage(channel, message);
          resolve(channel._url);
        })
        .onFailed(error => {
          reject(error);
        });
    });
  },
  handleNewMessage(channel, message) {
    let channels = store.getters["chatStore/channels"];
    let updatingChannel = channels.find(c => c._url === channel._url);

    if (updatingChannel == null) {
      updatingChannel = channel;
      channels.push(updatingChannel);
    }

    if (updatingChannel.messages == null) {
      updatingChannel.messages = [message];
    } else {
      updatingChannel.messages.unshift(message);
    }

    store.commit("chatStore/updateChannels", channels);
  },
  async getChannel(channelURL) {
    return await this.chat.groupChannel.getChannel(channelURL);
  },
  async deleteChannels(threads) {
    let channels = store.getters["chatStore/channels"];
    for (const thread of threads) {
      let deleteChannel = channels.find(c => c._url === thread.channelUrl);
      await deleteChannel.resetMyHistory();
      deleteChannel.messages = [];
    }
    store.commit("chatStore/updateChannels", channels);
  },
  async markAsRead(channelURL) {
    let channels = store.getters["chatStore/channels"];
    let channel = channels.find(c => c._url === channelURL);
    await channel.markAsRead();
    store.commit("chatStore/updateChannels", channels);
  },
  getGroupName(toParty) {
    return `${this.company.code}_${toParty.connectedCompanyCode}`;
  },
  getGroupNameReversed(toParty) {
    return `${toParty.connectedCompanyCode}_${this.company.code}`;
  },
};
